// extracted by mini-css-extract-plugin
module.exports = {"infrastructure-rows":"_7a3fb80146--infrastructure-rows--fdOT_","non-clickable-heading-wrapper":"_7a3fb80146--non-clickable-heading-wrapper--Nc3GG"};